import React, { useEffect, useRef } from 'react';

/**
 * Component for rendering an Iubenda Cookie Policy link
 * Handles the Iubenda script loading in a React-friendly way
 */
const IubendaCookiePolicy = () => {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Ensure script is loaded only once
    if (!scriptLoaded.current && !window.iubenda_object) {
      try {
        const script = document.createElement('script');
        script.src = 'https://cdn.iubenda.com/iubenda.js';
        script.async = true;
        script.onload = () => {
          scriptLoaded.current = true;
        };
        script.onerror = (error) => {
          console.error('Error loading Iubenda script:', error);
        };
        document.body.appendChild(script);
      } catch (error) {
        console.error('Error setting up Iubenda script:', error);
      }
    }

    // Cleanup function
    return () => {
      // No cleanup needed as script should remain loaded
    };
  }, []);

  return (
    <a 
      href="https://www.iubenda.com/privacy-policy/51681618/cookie-policy" 
      className="iubenda-white iubenda-noiframe iubenda-embed hover:text-green-400 transition-colors"
      title="Cookie Policy"
      rel="noopener noreferrer"
    >
      Cookie Policy
    </a>
  );
};

export default IubendaCookiePolicy;

